import React, { useCallback, useEffect, useState } from "react";
import * as Comp from "./components";
import * as images from "../../../images";
import * as Styles from "./styledVedCourse";
import { MuiButton } from "../../../Components/Form";
import { ButtonBase, CircularProgress, Typography } from "@mui/material";
import { Fade } from "react-reveal";
import HookVedCourse from "../../../hooks/VedCourse";
import { useModalContext } from "../../../Provider/ModalProvider";
import { ProgressLine } from "../../../Components/Form";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import VedioShow from "../../../hooks/VedCourse/VedioShow";
import Dots from "../../../Components/Loader/Dots";
import AddRatingModule from "../ratings/feature/AddRatingModule";
import {
  useAddVideoRateMutation,
  useGetVideoRatesQuery,
} from "../ratings/service/RatingService";
import { Wrapper } from "../ratings/components/Wrapper";
import { useSelector } from "react-redux";

import { useGetSessionsByIdQuery } from "./Service";
import RatingsModule from "../ratings/feature/RatingsModule";
import { Box } from "@mui/material";

import ImageViewer from "react-simple-image-viewer";
import UseGetData from "../../../HookAxios/getdata";
import { GET_REQUEST } from "../../../HooksApi/useApi";

const VedCourse = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const navigate = useNavigate();

  const { sectionId, id: idCourse } = useParams();

  const { openLockedAccessDepartment, openLockedAcsses } = useModalContext();
  const token = useSelector((state) => state.Auth.userInfo.token);
  console.log("the token is ======= ", token)
  const {
    id,
    AboutCourse,
    SectionsBy,
    SessionsBy,
    idUser,
    value,
    LoadPart,
    LoadParts,
    dataParts,
    dataVedio,
    ApiVed,
    idVed,
    expanded,
    handleChange,
    handleChangeComp,
    expandedComp,
    handleChangeCom,
    expandedCom,
    LoadPending,
    dataPending,
    DeleteComment,
    ShowVedio,
    setShowVedio,
    med,
    setWatch,
    dataProg,
    isLoading,
    loadingRefrances,
    getRefrences,
  } = HookVedCourse();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [dataVedio]);

  const { data: ratesData } = useGetVideoRatesQuery(idVed, token);
  const addRateData = useAddVideoRateMutation();

  // const {
  //   isLoading: isLoadingGetSesstion,
  //   data: dataGetSessstion,
  //   refetch: refetchSessions,
  // } = useGetSessionsByIdQuery(idCourse, token);
  let headers = {}
  if (token){
    headers = { Authorization: `Bearer ${token}` }
  }
  const { isLoading: isLoadingGetSesstion, data: dataGetSessstion } = GET_REQUEST({
    queryKey: `GetSectionsCourse${idCourse}`,
    request: () =>
      UseGetData(
        "get_sections_by_id",
        { id: idCourse },
        headers
      ),
    enabled: true,
  });
  console.log("the data issssssssssssss ",dataGetSessstion)
  return (
    <Styles.Section>
      {
        <Styles.LeftSection style={{ display: !ShowVedio && "block" }}>
          <Styles.DetailsCourse>
            <Styles.DetailsTitle>{AboutCourse?.data?.name}</Styles.DetailsTitle>

            {token ? (
              <Styles.ContentBox>
                <ProgressLine
                  value={
                    !isLoading && dataProg ? dataProg?.data?.data?.progress : 0
                  }
                  backgroundactive="#0056D2"
                />
                <span>
                  {!isLoading && dataProg
                    ? Number(dataProg?.data?.data?.progress).toFixed(1)
                    : 0}
                  %{" "}
                </span>
              </Styles.ContentBox>
            ) : null}

            {dataGetSessstion?.data?.data?.sections?.map((el) => (
              <Styles.Accordion
                key={el.id}
                expanded={expanded === el.id}
                onChange={handleChange(el.id)}
              >
                <Styles.AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Styles.AccordionContent>
                    <Styles.AccordionContentText>
                      <Styles.Icon
                        style={{ transform: "scale(0.8)" }}
                        src={images.CerBeg}
                        alt=""
                      />
                      <Styles.AccordionText>{el.name}</Styles.AccordionText>
                    </Styles.AccordionContentText>
                  </Styles.AccordionContent>
                </Styles.AccordionSummary>
                <Styles.AccordionDetails>
                  {!LoadParts && dataParts ? (
                    dataParts?.data?.data?.videos?.map((element) => (
                      <Styles.AccordionContentVed
                        key={element.id}
                        component={
                          element?.is_public ||
                          (!element.is_public && element.is_subscribtion)
                            ? NavLink
                            : ButtonBase
                        }
                        onClick={
                          element?.is_public ||
                          (!element.is_public && element.is_subscribtion)
                            ? null
                            : openLockedAcsses
                        }
                        to={`/course-description/${id}/${sectionId}/${element.id}`}
                      >
                        <Styles.AccordionContentVedItems>
                          {element?.is_public ||
                          (!element?.is_public && element?.is_subscribtion) ? (
                            element.is_watched ? (
                              <Styles.Icon src={images.ArrowLeft} alt="true" />
                            ) : (
                              <Styles.Icon src={images.CerSmal} alt="" />
                            )
                          ) : (
                            <Styles.Icon src={images.LockOutline} alt="" />
                          )}
                          <Styles.AccordionTextDetails
                            sx={{ fontSize: "14px" }}
                          >
                            <Typography
                              sx={{ fontSize: "0.9rem", fontWeight: "200" }}
                              onClick={() => setShowVedio(true)}
                            >
                              {element.Title}
                            </Typography>
                          </Styles.AccordionTextDetails>
                        </Styles.AccordionContentVedItems>
                      </Styles.AccordionContentVed>
                    ))
                  ) : (
                    <center>
                      {" "}
                      <CircularProgress
                        sx={{ alignSelf: "center", width: "8px" }}
                      />
                    </center>
                  )}
                  {el.quiz && (
                    <Styles.AccordionContentVed
                      component={
                        // el?.is_public || !el.is_public && el.is_subscribtion ?
                        Link
                        // : ButtonBase
                      }
                      style={{ width: "100%" }}
                      //  onClick={el?.is_public || !el.is_public && el.is_subscribtion ? '' : openLockedAcsses}
                      to={`/test-unit/${el.id}`}
                    >
                      <Styles.AccordionContentVedItems>
                        {/* {
                                                            el?.is_public || !el.is_public && el.is_subscribtion ?
                                                                <Style.Icon src={''} alt="" />

                                                                :
                                                                <Style.Icon src={Images.LockOutline} alt="" />
                                                        } */}
                        <Typography sx={{ fontSize: "14px" }}>
                          اختبار الوحدة
                        </Typography>
                      </Styles.AccordionContentVedItems>
                    </Styles.AccordionContentVed>
                  )}
                </Styles.AccordionDetails>
              </Styles.Accordion>
            ))}
          </Styles.DetailsCourse>
          <Styles.ContentFlex></Styles.ContentFlex>
        </Styles.LeftSection>
      }

      {ShowVedio ? (
        <Styles.RightSection>
          {!LoadPart && dataVedio?.data?.data ? (
            <Fade>
              <Styles.TitleDisc>
                <img src={images.CameraVed} alt="" />
                {dataVedio.data.data.Title
                  ? dataVedio?.data?.data?.Title
                  : dataVedio?.data?.data?.title}
              </Styles.TitleDisc>
              <Styles.VideoSection>
                {dataVedio?.data?.data?.is_public ||
                (!dataVedio?.data?.data?.is_public &&
                  dataVedio?.data?.data?.is_subscribtion) ? (
                  <Styles.VideoPlay>
                    <VedioShow
                      id={dataVedio.data?.data.script_code}
                      setWatch={setWatch}
                    />
                  </Styles.VideoPlay>
                ) : (
                  openLockedAcsses()
                )}
              </Styles.VideoSection>
            </Fade>
          ) : (
            <Dots />
          )}
          <Styles.ContentBoxForm>
            {idUser && <Comp.FormComment />}
            {dataPending?.data?.data[1]?.Pending_Questions?.length && idUser ? (
              <Styles.Accordion
                expanded={expandedComp === 1}
                onChange={handleChangeComp(1)}
              >
                <Styles.AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Styles.AccordionContent>
                    <Styles.AccordionContentText>
                      {/* <HelpOutlineOutlinedIcon sx={{ color: '#333333', width: '16px' }} /> */}
                      <Styles.AccordionText
                        sx={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        أسئلة قيد الانتظار
                      </Styles.AccordionText>
                    </Styles.AccordionContentText>
                  </Styles.AccordionContent>
                </Styles.AccordionSummary>
                <Styles.AccordionDetails>
                  {!LoadPending && dataPending ? (
                    dataPending?.data?.data[1]?.Pending_Questions.map((el) => (
                      <Comp.QuestionPindling
                        key={el.id}
                        comment={el.comment}
                        images={el.images}
                        DeleteComment={DeleteComment}
                        id={el.id}
                      />
                    ))
                  ) : (
                    <center>
                      {" "}
                      <CircularProgress
                        sx={{ alignSelf: "center", width: "8px" }}
                      />
                    </center>
                  )}
                </Styles.AccordionDetails>
              </Styles.Accordion>
            ) : null}

            {dataPending?.data?.data[0]?.Questions != undefined && (
              <Styles.Accordion
                expanded={expandedComp === 2}
                onChange={handleChangeComp(2)}
              >
                <Styles.AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Styles.AccordionContent>
                    <Styles.AccordionContentText>
                      <Styles.AccordionText
                        sx={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        الاستفسارات
                      </Styles.AccordionText>
                    </Styles.AccordionContentText>
                  </Styles.AccordionContent>
                </Styles.AccordionSummary>
                <Styles.AccordionDetails>
                  {!LoadPending && dataPending?.data?.data[0]?.Questions
                    ? dataPending?.data?.data[0]?.Questions.map((el) => (
                        <Styles.AccordionContentVed boxshadow="none">
                          <Styles.Accordion
                            expanded={expandedCom === el.id}
                            onChange={handleChangeCom(el.id)}
                            style={{
                              width: "100%",
                              borderRadius: "4px",
                              boxShadow: "none",
                            }}
                          >
                            <Styles.AccordionSummary
                              aria-controls="panel1d-content"
                              id="panel1d-header"
                            >
                              <Styles.AccordionContent>
                                <Styles.AccordionContentText>
                                  <Styles.AccordionText
                                    sx={{ fontWeight: "400", fontSize: "16px" }}
                                  >
                                    {el.image_path ? (
                                      <img
                                        alt=""
                                        style={{
                                          width: "48px",
                                          height: "48px",
                                        }}
                                        src={`https://admin.talebeduction.com${el.image_path}`}
                                      />
                                    ) : (
                                      <img
                                        alt=""
                                        style={{
                                          width: "48px",
                                          height: "48px",
                                        }}
                                        src={images.user}
                                      />
                                    )}
                                  </Styles.AccordionText>
                                  <Styles.AccordionContent sx={{ gap: "4px" }}>
                                    <Styles.AccordionText
                                      style={{
                                        fontWeight: "500",
                                        fontSize: "14px",
                                        color: "#0D0A84",
                                      }}
                                    >
                                      {el.user_name}
                                    </Styles.AccordionText>
                                    <Styles.AccordionText
                                      style={{
                                        fontWeight: "400",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {el?.comment}
                                    </Styles.AccordionText>
                                  </Styles.AccordionContent>
                                </Styles.AccordionContentText>

                                <Box
                                  sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "10px",
                                  }}
                                >
                                  {el.images.map(({ image }, index) => (
                                    <img
                                      style={{
                                        width: "70px",
                                      }}
                                      src={image}
                                      alt="question"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        openImageViewer(index);
                                      }}
                                    />
                                  ))}
                                  <Box
                                    sx={{
                                      position: "relative",
                                      zIndex: "1000",
                                    }}
                                  >
                                    {isViewerOpen && (
                                      <ImageViewer
                                        src={el.images.map(
                                          ({ image }) => image
                                        )}
                                        currentIndex={currentImage}
                                        disableScroll={false}
                                        closeOnClickOutside={true}
                                        onClose={closeImageViewer}
                                      />
                                    )}
                                  </Box>
                                </Box>
                              </Styles.AccordionContent>
                            </Styles.AccordionSummary>
                            <Styles.AccordionDetails
                              style={{ padding: "0px  8px " }}
                            >
                              <Styles.AccordionContentVed
                                style={{ padding: "0px 60px " }}
                                boxshadow="none"
                              >
                                <Styles.AccordionContentVedItems>
                                  <Styles.AccordionTextDetails
                                    sx={{
                                      fontSize: "14px",
                                      color: "#0000005b",
                                      padding: "10px",
                                    }}
                                  >
                                    {el?.reply?.comment}
                                  </Styles.AccordionTextDetails>
                                </Styles.AccordionContentVedItems>
                              </Styles.AccordionContentVed>
                            </Styles.AccordionDetails>
                          </Styles.Accordion>
                        </Styles.AccordionContentVed>
                      ))
                    : ""}
                </Styles.AccordionDetails>
              </Styles.Accordion>
            )}

            {getRefrences?.data?.data?.refrences != undefined && (
              <Styles.Accordion
                expanded={expandedComp === 3}
                onChange={handleChangeComp(3)}
              >
                <Styles.AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Styles.AccordionContent>
                    <Styles.AccordionContentText>
                      <Styles.AccordionText
                        sx={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        المراجع
                      </Styles.AccordionText>
                    </Styles.AccordionContentText>
                  </Styles.AccordionContent>
                </Styles.AccordionSummary>

                <Styles.AccordionDetails>
                  <Styles.AccordionContentVed boxshadow="none">
                    <Styles.AccordionContentVedItems>
                      {!loadingRefrances && getRefrences?.data?.data?.refrences
                        ? getRefrences.data?.data?.refrences.map((ref) => (
                            <a
                              href={`${process.env.REACT_APP_BASE_URL}${
                                ref?.file_path !== ""
                                  ? ref?.file_path
                                  : ref?.content
                              }`}
                              download="Example-PDF-document"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Styles.AccordionTextDetails
                                sx={{
                                  fontSize: "14px",
                                  color: "#0000005b",
                                  padding: "10px",
                                }}
                              >
                                {ref?.refrence_name !== ""
                                  ? ref.refrence_name
                                  : "تحميل المرجع"}
                              </Styles.AccordionTextDetails>
                            </a>
                          ))
                        : "لا يوجد مراجع حاليا لهذه الجلسة."}
                    </Styles.AccordionContentVedItems>
                  </Styles.AccordionContentVed>
                </Styles.AccordionDetails>
              </Styles.Accordion>
            )}

            {!LoadPart && dataVedio.data.data.quiz && idUser ? (
              <Styles.Accordion
                expanded={expandedComp === 4}
                onChange={handleChangeComp(4)}
                onClick={() =>
                  navigate(`/testCourse/${dataVedio.data.data.id}`)
                }
              >
                <Styles.AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                >
                  <Styles.AccordionContent>
                    <Styles.AccordionContentText>
                      {/* <HelpOutlineOutlinedIcon sx={{ color: '#333333', width: '16px' }} /> */}
                      <Styles.AccordionText
                        sx={{ fontWeight: "400", fontSize: "16px" }}
                      >
                        تقديم الاختبار
                      </Styles.AccordionText>
                    </Styles.AccordionContentText>
                  </Styles.AccordionContent>
                </Styles.AccordionSummary>
                {/* <Styles.AccordionDetails>
                  <Styles.AccordionContentVed boxshadow="none">
                    <Styles.AccordionContentVedItems>
                      <Styles.AccordionTextDetails
                        sx={{
                          fontSize: "14px",
                          color: "#0000005b",
                          padding: "10px",
                        }}
                      >
                        <Styles.AccordionTextDetails
                          component={Link}
                          to={`/testCourse/${dataVedio.data.data.id}`}
                          sx={{ fontSize: "14px", textDecoration: "none" }}
                        >
                          تقديم الاختبار
                        </Styles.AccordionTextDetails>
                      </Styles.AccordionTextDetails>
                    </Styles.AccordionContentVedItems>
                  </Styles.AccordionContentVed>
                </Styles.AccordionDetails> */}
              </Styles.Accordion>
            ) : null}
            {(dataVedio?.data?.data?.is_public ||
              (!dataVedio?.data?.data?.is_public &&
                dataVedio?.data?.data?.is_subscribtion)) &&
              idUser && (
                <Wrapper>
                  <AddRatingModule
                    sessionId={idVed}
                    addRate={addRateData.mutate}
                    isLoading={addRateData.isLoading}
                    isSuccess={addRateData.isSuccess}
                    placeholder={"ما هو تقييمك لهذا الدرس؟"}
                  />
                </Wrapper>
              )}
            <RatingsModule rateData={ratesData} />
          </Styles.ContentBoxForm>
        </Styles.RightSection>
      ) : null}
      {med ? (
        !ShowVedio ? (
          <MuiButton
            text=" إخفاء المحتوى"
            background="#0056D2"
            margin="0 auto"
            color="#fff"
            width="80%"
            height="40px"
            onClick={() => setShowVedio(true)}
          />
        ) : (
          <MuiButton
            text=" اظهار المحتوى"
            background="#0056D2"
            margin="0 auto"
            color="#fff"
            width="80%"
            height="40px"
            onClick={() => setShowVedio(false)}
          />
        )
      ) : null}
    </Styles.Section>
  );
};

export default VedCourse;
